import React, { Component } from 'react';
import axios from 'axios';
import _ from 'lodash';
import './App.css';
import { Col, Container, FormGroup, FormText, Input, Label, Row } from "reactstrap";
import FirstStep from "./FirstStep";
import SecondStep from "./SecondStep";
import ThirdStep from "./ThirdStep";
import { Elements, injectStripe } from "react-stripe-elements";
import FourthStep from "./FourthStep";

const test = false;

const StripeUrl = test ? 'http://localhost/payment/uploader.php' : `https://www.asei.fr/payment/uploader.php`;

const appendFormdata = (FormData, data, name) => {
    name = name || '';

    if (typeof data === 'object' && !(data instanceof File)) {
        _.map(data, (value, index) => {
            if (name == '') {
                appendFormdata(FormData, value, index);
            } else {
                appendFormdata(FormData, value, name + '[' + index + ']');
            }
        })
    } else {

        FormData.append(name, data);
    }
};

class App extends Component {

    constructor(props) {
        super(props)

        this.nextPage = this.nextPage.bind(this)
        this.submit = this.submit.bind(this)
        this.previousPage = this.previousPage.bind(this)
        this.state = {
            page: 1
        }
    }
    nextPage() {
        this.setState({ page: this.state.page + 1 })
        window.scrollTo(0, 0)
    }

    submit(data) {

        return this.props.stripe.createSource({ owner: { name: `${data.nameCard}` } }).then((dt) => {
            data.tokenStripe = dt.source;
            const formData = new FormData();
            appendFormdata(formData, data);

            const request = axios.post(StripeUrl, formData);

            return request
                .then(response => {
                    //window.location.href = response.data;
                    this.props.stripe.redirectToCheckout({
                        sessionId: response.data
                    }).then((result) => {
                        if (result.error.message) {
                            console.log(result.error.message);
                        }
                    });
                })
                .catch((error) => {

                });
        });
    }

    previousPage() {
        this.setState({ page: this.state.page - 1 })
        window.scrollTo(0, 0)
    }

    render() {

        const { page } = this.state;

        return (
            <Container className="conta">
                <Row>
                    <Col xs="12" sm={{ size: 8, offset: 2 }}>
                        <ul className="progressbar" >
                            <li className={page == 1 ? "active" : ""} />
                            <li className={page == 2 ? "active" : ""} />
                            <li className={page == 3 ? "active" : ""} />
                            <li className={page == 4 ? "active" : ""} />
                        </ul>
                        {page === 1 && <FirstStep onSubmit={this.nextPage} previous={this.previousPage} />}
                        {page === 2 && <SecondStep onSubmit={this.nextPage} previous={this.previousPage} />}
                        {page === 3 && <ThirdStep onSubmit={this.nextPage} previous={this.previousPage} />}
                        {page === 4 &&
                            <FourthStep onSubmit={this.submit} previous={this.previousPage} />
                        }
                    </Col>
                </Row>
                <Row>
                    <Col style={{ fontSize: "8px" }}>
                        v1.5.1
                  </Col>
                </Row>
            </Container>
        );
    }
}

export default injectStripe(App);



// WEBPACK FOOTER //
// ./src/App.js